// extracted by mini-css-extract-plugin
module.exports = {"desktopLayout":"CarComparisonDesktopTable_desktopLayout__TbkwI","chatbotWrapper":"CarComparisonDesktopTable_chatbotWrapper__AiUna"};